<button
  class="cta-badge"
  [ngClass]="[color(), size(), shape(), isIconOnly() ? 'icon-only' : '']"
  [class.highlighted]="highlighted()"
  [class.disabled]="disabled()"
  [attr.aria-label]="ariaLabel() ?? text()"
  [disabled]="disabled()"
  (click)="onClick()"
>
  @if (icon()) {
    <ptl-icon (click)="onIconClick()" (keydown)="onIconClick()" [icon]="icon()" [size]="'xs'"></ptl-icon>
  }

  <span class="button-text" *ngIf="text()" [innerHTML]="text()"></span>

  <ng-content></ng-content>

  @if (iconSuffix()) {
    <ptl-icon (click)="onIconClick()" (keydown)="onIconClick()" [icon]="iconSuffix()" [size]="'xs'"></ptl-icon>
  }
</button>
